import React from 'react';

/**
 * Page title block (same type scale as the dashboard's "Emissions overview" header):
 * a large title, a quiet one-line subtitle, optional actions on the right.
 */
export default function PageHeader({ title, subtitle, actions, className = '' }) {
  if (!title) return null;
  return (
    <div className={`page-header mb-6 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between ${className}`}>
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground sm:text-[28px]">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:gap-3">{actions}</div>}
    </div>
  );
}

/** Titles for the Scope 3 tabs (kept here so the page file only needs one line). */
export const SCOPE3_HEADS = {
  travel: { title: 'Business travel', subtitle: 'Cat 6 · flights, rail, road and hotel stays with UK DESNZ 2026 factors' },
  commute: { title: 'Employee commute', subtitle: 'Cat 7 · commuting and homeworking' },
  activities: { title: 'My activities', subtitle: 'Scope 3 activities across freight, business travel and commuting' },
  surveys: { title: 'Commute surveys', subtitle: 'Collect employee commuting and homeworking data for Cat 7' },
};
